import { t } from "@core/idtek-component";

export const BookingParam = ':booking';

export const HistoryMapping = {
    history: '/history',
};

export const BookingMapping = {
    bookingRouter: '/booking/:locationCode',
};


export const BookingApi = {
    getBranch: '/booking-online/get-branch',
    getService: '/booking-online/get-service',
    getTime: '/booking-online/get-time',
    getTimeAvailable: '/booking-online/get-time-available',
    getMonthAvailable: '/booking-online/get-month-available',
    getTechnician: '/booking-online/get-technicians',
    getReview: '/booking-online/get-review',
    getBooking: '/booking-online/get-booking',
    getDetailBooking: '/booking-online/show',
    postBranch: '/booking-online/branch',
    postTime: '/booking-online/time',
    postService: '/booking-online/service',
    postContact: '/booking-online/contact',
    checkSessionId: '/booking-online/check-session',
    postReview: '/booking-online/review',
    postCache: "/booking-online/post-cache",
    getCache: "/booking-online/get-cache",
    getListReview: "/booking-online/get-list-review"
};

export const infoFormModel = {
    fields: {
        name: {placeholder: `${t('TYPE_YOUR_NAME')}`, label: t('NAME')},
        description: {placeholder: `${t('NOTE')}...`, label: t('NOTE')},
        phone: {placeholder: `${t('TYPE_YOUR_PHONE_NUMBER')}`, label: t('PHONE_NUMBER')},
    }
};

export const TypeSegment = "service"


export const blankTime = 30;